import React from 'react';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';

import { PrimaryButton } from '../blocks';

function Footer({ isFirst, isLast, hasErrors, callbacks, state }) {
    return (
        <Grid
            container
            css={css`
                margin-top: 40px;
                margin-bottom: 64px;
                justify-content: space-between;
            `}
        >
            <PrimaryButton
                css={css`
                    padding: 12px 24px;
                `}
                onClick={callbacks.revert}
            >
                Back
            </PrimaryButton>

            <PrimaryButton
                disabled={hasErrors || state.isLoading}
                onClick={callbacks.advance}
                css={css`
                    padding: 12px 24px;
                `}
            >
                {isLast ? 'Submit' : 'Next'}
            </PrimaryButton>
        </Grid>
    );
}

export default Footer;
